/// <reference path='_all.ts' />


// CHEAT SHEET: http://ivision.com/wp-content/uploads/AngularJS_v2.pdf


/**
 * The main Menu.
 *
 * @type {angular.Module}
 */
module navigation {
  'use strict';

  var nav = angular.module('navigation', ['ngAnimate', 'user', 'angular-cache', 'templates', 'angulartics', 'angulartics.google.tagmanager', 'youTubeOverlay', 'editableContent'])
    .config(['$httpProvider', '$anchorScrollProvider', function ($httpProvider: ng.IHttpProvider, $anchorScrollProvider : ng.IAnchorScrollProvider) {
        $httpProvider.interceptors.push(LoadingInterceptor.Factory);
        $anchorScrollProvider.disableAutoScrolling();
    }])
    .config(['$analyticsProvider', function ($analyticsProvider) { 
      $analyticsProvider.trackExceptions(true);
      $analyticsProvider.virtualPageviews(false); //turn off automatic tracking      
      $analyticsProvider.firstPageview(false); //turn off automatic tracking       
    }])
    .controller('MenuCtrl', MenuCtrl)
    .directive('onFinishRender', onFinishRender)
    .directive('itemNavigation', ItemNavigationDirective)
    .directive('responsiveImage', responsiveImage)
    .directive('anchorNav', anchorNav)
    .directive('scrollTo', scrollTo)
    .directive('trackPageView', trackPageViewDirective)
    .service('anchorNavService', navigation.AnchorNavService) 
    .service('pageMetaService', navigation.PageMetaService) 
    .service('loadingIndicatorService', navigation.LoadingIndicatorService) 
    .service('parallaxService', navigation.ParallaxService) 
    .service('visibilityApiService', navigation.VisibilityApiService) 
    .factory('debounce', debounceService)
    .factory('loadingInterceptor', navigation.LoadingInterceptor);

  
}